import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationRow',
  props: {
    locationName: null,
    type: null,
    highlightRow: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  locationName?: string | null
  type: 'pickup' | 'destination'
  highlightRow?: boolean
}



const icon = computed(() => {
  if (props.type === 'pickup') {
    return 'mdi-map-marker'
  } else {
    return 'mdi-flag'
  }
})

return { __sfc: true,props, icon }
}

})